import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  NgbActiveModal,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { AuthService } from '@core';
import { Direction } from '@angular/cdk/bidi';
import moment from 'moment';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import { ModalReglementHebergementComponent } from '../modal-reglement-hebergement/modal-reglement-hebergement.component';
import { ModalReglementLivraisonRestauComponent } from '../../../restaurant/livraison-restaurant/modal-reglement-livraison-restau/modal-reglement-livraison-restau.component';
import { ModalReglementLivraisonBoutiqueComponent } from '../../../boutique/livraison-boutique/modal-reglement-livraison-boutique/modal-reglement-livraison-boutique.component';
import { PrintService } from '@core/service/print.service';

@Component({
  selector: 'app-modal-sortie-client',
  imports: [CommonModule, FormsModule, IntegerFormatPipe],
  templateUrl: './modal-sortie-client.component.html',
  styleUrl: './modal-sortie-client.component.scss',
})
export class ModalSortieClientComponent implements OnInit {
  action: string | undefined;
  itemData: any = null;
  dialogTitle: string = '';
  // bookingForm: UntypedFormGroup;
  // booking: Article;
  client_search_key: any;
  itemToSave: any = {};
  itemsNationnalite: any = [
    {
      user_nationnalite_name: 'IVOIRIENNE',
      user_nationnalite_id: 'IVOIRIENNE',
    },
    { user_nationnalite_name: 'BURKINABE', user_nationnalite_id: 'BURKINABE' },
    {
      user_nationnalite_name: 'SENEGALAIS',
      user_nationnalite_id: 'SENEGALAIS',
    },
  ];
  itemsNaturePiece: any = [
    {
      nature_piece_name: 'CARTE_IDENTITE',
      user_nature_of_piece: 'CARTE_IDENTITE',
    },
    { nature_piece_name: 'PASSEPORT', user_nature_of_piece: 'PASSEPORT' },
    {
      nature_piece_name: 'PERMIS_CONDUIRE',
      user_nature_of_piece: 'PERMIS_CONDUIRE',
    },
  ];
  createMessage = '';
  editMessage = '';
  deleteMessage = '';
  gender = 'M';
  entity = 'booking';
  isLoading: boolean = false;
  itemsRoom: any;
  endPoint: string = 'hebergement';
  title = 'sortie client';

  // Sortie avec perte
  is_sortie_perte: boolean = false;
  raison_perte: string = '';
  justifImage: { fileBase64: any; fileName: any; extension: any; typeDocument: string } | undefined;
  justifImageName: string | undefined;
  justifImageDisplay: any;

  itemClient: any = {};
  user: any = {};
  itemsService: any;
  itemsChambre: any;
  itemsClient: any;

  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage:
    | {
        fileBase64: any;
        fileName: any;
        extension: any;
        typeDocument: string;
      }
    | undefined;
  loading: boolean | undefined;
  showTimeFiels: boolean = false;
  duree_jours: any = 0;
  duree_heures: any = 0;
  itemsRaisonSortie: any;
  itemsLivraison: any[] = [];
  itemsReglementHeberg: any[] = [];
  showReglementsHeberg: boolean = false;
  livraisonDetails: { [id: number]: any[] } = {};
  expandedLivraisons: Set<number> = new Set();
  loadingDetailId: number | null = null;
  reglementLivraisonMap: { [id: number]: any[] } = {};
  expandedReglements: Set<number> = new Set();

  constructor(
    public activeModal: NgbActiveModal,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private authService: AuthService,
    private modalService: NgbModal,
    public printService: PrintService
  ) {
    this.user = this.authService.getCurrentUser();
    let text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage =
      'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage =
      'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage =
      'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;
  }

  ngOnInit() {
    this.action = this.itemData?.action || this.action;
    if (this.action === 'edit') {
      this.itemToSave = { ...this.itemData };
      if (this.itemData?.image_url) {
        this.imageDisplay = this.itemData.image_url;
      }
      this.onSearchClient(this.itemToSave.client_id);
      this.getitemsChambre();
      this.getItemsLivraison();
      this.getItemsReglementHeberg();
    }
    this.getItemsService();
    this.getItemsRaisonSortie();
  }

  submit() {}

  confirmSaveItem(item: any) {
    let objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // objToSave.code = objToSave.code.trim().toUpperCase();
        this.saveItem(objToSave);
      }
    });
  }

  saveItem(item: any) {
    console.info('item to save', item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    let reduce = [];

    itemAEnregistrer.groupe_id = this.user.groupe_id;
    itemAEnregistrer.hotel_id = this.user.hotel_id;
    itemAEnregistrer.is_sortie = true;
    itemAEnregistrer.is_clotured = false;
    itemAEnregistrer.date_sortie = moment();

    if (this.is_sortie_perte && this.totalResteGlobal > 0) {
      itemAEnregistrer.is_sortie_perte = 1;
      itemAEnregistrer.montant_perte = this.totalResteGlobal;
      itemAEnregistrer.raison_perte = this.raison_perte;
      if (this.justifImage) {
        itemAEnregistrer.file_data = this.justifImage;
      }
    }

    var request = {
      datas: [itemAEnregistrer],
    };

    this.restClient
      .post(
        this.endPoint + '' + (itemAEnregistrer.id ? '/update' : '/update'),
        request
      )
      .subscribe(
        (res: any) => {
          console.info('resul', res);
          this.isLoading = false;

          if (!res['hasError']) {
            this.utilities.showNotification(
              'snackbar-success',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
            // this.currentPage = 0
            this.activeModal.close(res.item);
            // this.imprimerReglement(res.item);
          } else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification(
                'snackbar-danger',
                this.utilities.formatMsgServeur(res['status']['message']),
                'bottom',
                'center'
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.getMessageEndPointNotAvailble(),
            'bottom',
            'center'
          );
          this.loading = false;
        }
      );
  }
  getItemsService() {
    this.itemsChambre = [];
    let request = {
      data: {
        can_reservation: true,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('service/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsService = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsService = [];
        }
      },
      (err) => {
        this.itemsService = [];
      }
    );
  }
  getItemsRaisonSortie() {
    this.itemsChambre = [];
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('raisonSortie/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsRaisonSortie = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsRaisonSortie = [];
        }
      },
      (err) => {
        this.itemsRaisonSortie = [];
      }
    );
  }

  uploadJustif(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];
      this.justifImageName = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.justifImageDisplay = data;
        this.justifImage = {
          fileBase64: data.split(',')[1],
          fileName,
          extension,
          typeDocument: 'justif_perte',
        };
      };
      reader.readAsDataURL(file);
    }
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.imageName = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getitemsChambre() {
    if (
      (!this.itemToSave.id && !this.itemToSave.service_id) ||
      !this.itemToSave.debut_reservation ||
      !this.itemToSave.fin_reservation
    )
      return;
    let request: any = {
      data: {},
      index: 0,
      size: 10000,
    };

    if (!this.itemToSave.id) {
      request.chambre_status = 'AVAILABLE'; // POUR RECUPER UNIQUEMENT LES CHAMBRES DISPONIBLES
      request.service_id = this.itemToSave.service_id;
      request.debut_reservation = this.itemToSave.debut_reservation;
      request.fin_reservation = this.itemToSave.fin_reservation;
    }
    this.restClient.post('chambre/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsChambre = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsChambre = [];
        }
      },
      (err) => {
        this.itemsChambre = [];
      }
    );
  }
  getItemsReglementHeberg() {
    if (!this.itemToSave.id) return;
    this.restClient
      .post('reglementHebergement/getByCriteria', {
        data: { hebergement_id: this.itemToSave.id },
        index: 0,
        size: 10000,
      })
      .subscribe(
        (res: any) => {
          this.itemsReglementHeberg =
            res && res['items'] && !res['hasError'] ? res['items'] : [];
        },
        () => {
          this.itemsReglementHeberg = [];
        }
      );
  }

  getitemsHebergement() {
    let request: any = {
      data: {
        id: this.itemToSave.id,
      },
      index: 0,
      size: 10000,
    };
    this.restClient.post('hebergement/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemToSave = res['items'][0];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
        }
      },
      (err) => {}
    );
  }

  onSearchClient(client_id?: any) {
    // if(!this.client_search_key) return
    let request = {
      chambre_status: 'AVAILABLE', // POUR RECUPER UNIQUEMENT LES CHAMBRES DISPONIBLES
      service_id: this.itemToSave.service_id,
      debut_reservation: this.itemToSave.debut_reservation,
      fin_reservation: this.itemToSave.fin_reservation,
      search_key: this.client_search_key,
      data: {
        // telephone:this.client_search_key
        id: client_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('client/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsClient = res['items'];
          if (client_id) this.itemToSave.client_id = client_id;
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsClient = [];
        }
      },
      (err) => {
        this.itemsClient = [];
      }
    );
  }
  onGetChambreDisponible() {
    this.itemToSave.chambre_id = null;
    this.getitemsChambre();
  }

  calculatePrice() {
    // debugger
    if (this.itemToSave.chambre_id && !this.showTimeFiels) {
      const selected_chambre = this.itemsChambre.find(
        (ic: any) => ic.id == this.itemToSave.chambre_id
      );
      const dateDebut = moment(this.itemToSave.debut_reservation);
      const dateFin = moment(this.itemToSave.fin_reservation);
      const jours = dateFin.diff(dateDebut, 'days');
      this.duree_jours = jours;
      this.itemToSave.montant_total =
        this.duree_jours * selected_chambre.montant_service;
    } else {
      if (this.itemToSave.chambre_id) {
        const selected_chambre = this.itemsChambre.find(
          (ic: any) => ic.id == this.itemToSave.chambre_id
        );
        this.itemToSave.montant_total = selected_chambre.montant_service;
        this.duree_heures = 10;
      }
    }
  }

  onSetHeure() {
    const selected_service = this.itemsService.find(
      (is: any) => is.id === this.itemToSave.service_id
    );

    this.showTimeFiels = false;

    if (
      selected_service?.periodicite_heure_debut &&
      selected_service?.periodicite_heure_fin
    ) {
      this.showTimeFiels = true;

      this.itemToSave.heure_debut_reservation =
        selected_service.periodicite_heure_debut;
      this.itemToSave.heure_fin_reservation =
        selected_service.periodicite_heure_fin;

      if (
        this.itemToSave.debut_reservation &&
        this.itemToSave.heure_debut_reservation
      ) {
        const t = moment(this.itemToSave.heure_debut_reservation, 'HH:mm');

        // Make sure debut_reservation is a moment object
        let debutMoment = moment(this.itemToSave.debut_reservation);

        if (t.isValid() && t.format('HH:mm') === '20:00') {
          // Add 1 day
          debutMoment.add(1, 'days');
        }
        // Set fin_reservation
        this.itemToSave.fin_reservation = debutMoment.toDate();
      }
    }
    this.onGetChambreDisponible();
  }

  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);

    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }
  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  openDialog(action: 'add' | 'edit', data?: any) {
    data = this.itemToSave;
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(ModalReglementHebergementComponent, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.data = { ...data, action };
    modalRef.closed.subscribe((result) => {
      console.log('result: ', result);
      if (result && result.id) this.onSearchClient(result.id);

      this.getitemsHebergement();
      this.getItemsReglementHeberg();
    });
  }

  openReglementLivraison(liv: any) {
    const isRestau = liv.type_commande_codification === 'RESTAURANT';
    const component = isRestau
      ? ModalReglementLivraisonRestauComponent
      : ModalReglementLivraisonBoutiqueComponent;

    const varDirection: Direction =
      localStorage.getItem('isRtl') === 'true' ? 'rtl' : 'ltr';
    const modalRef = this.modalService.open(component as any, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.data = { ...liv, action: 'add' };
    modalRef.closed.subscribe((result) => {
      if (result) this.getItemsLivraison();
    });
  }

  getItemsLivraison() {
    if (!this.itemToSave.id) return;
    this.restClient
      .post('livraison/getByCriteria', {
        data: { hebergement_id: this.itemToSave.id },
        index: 0,
        size: 10000,
      })
      .subscribe(
        (res: any) => {
          this.itemsLivraison =
            res && res['items'] && !res['hasError'] ? res['items'] : [];
        },
        () => {
          this.itemsLivraison = [];
        }
      );
  }

  toggleDetail(liv: any) {
    const id: number = liv.id;
    if (this.expandedLivraisons.has(id)) {
      this.expandedLivraisons.delete(id);
      return;
    }
    this.expandedLivraisons.add(id);
    if (this.livraisonDetails[id]) return; // already loaded
    this.loadingDetailId = id;
    this.restClient
      .post('livraisonDetail/getByCriteria', {
        data: { livraison_id: id },
        index: 0,
        size: 10000,
      })
      .subscribe(
        (res: any) => {
          this.livraisonDetails[id] =
            res && res['items'] && !res['hasError'] ? res['items'] : [];
          this.loadingDetailId = null;
        },
        () => {
          this.livraisonDetails[id] = [];
          this.loadingDetailId = null;
        }
      );
  }

  isExpanded(id: number): boolean {
    return this.expandedLivraisons.has(id);
  }

  toggleReglements(liv: any) {
    const id: number = liv.id;
    if (this.expandedReglements.has(id)) {
      this.expandedReglements.delete(id);
      return;
    }
    this.expandedReglements.add(id);
    if (this.reglementLivraisonMap[id]) return;
    this.restClient.post('reglementAutre/getByCriteria', {
      data: { livraison_id: id },
      index: 0,
      size: 10000,
    }).subscribe(
      (res: any) => {
        this.reglementLivraisonMap[id] = res?.items && !res['hasError'] ? res.items : [];
      },
      () => { this.reglementLivraisonMap[id] = []; }
    );
  }

  isExpandedReglements(id: number): boolean {
    return this.expandedReglements.has(id);
  }

  get livraisonsRestau(): any[] {
    return this.itemsLivraison.filter(
      (l: any) => l.type_commande_codification === 'RESTAURANT'
    );
  }

  get livraisonsBoutique(): any[] {
    return this.itemsLivraison.filter(
      (l: any) => l.type_commande_codification === 'BOUTIQUE'
    );
  }

  get totalMontantRestau(): number {
    return this.livraisonsRestau.reduce(
      (s: number, l: any) => s + (l.montant_total || 0),
      0
    );
  }

  get totalRegleRestau(): number {
    return this.livraisonsRestau.reduce(
      (s: number, l: any) => s + (l.total_regle || 0),
      0
    );
  }

  get totalResteRestau(): number {
    return this.livraisonsRestau.reduce(
      (s: number, l: any) => s + (l.reste_a_regler || 0),
      0
    );
  }

  get totalMontantBoutique(): number {
    return this.livraisonsBoutique.reduce(
      (s: number, l: any) => s + (l.montant_total || 0),
      0
    );
  }

  get totalRegleBoutique(): number {
    return this.livraisonsBoutique.reduce(
      (s: number, l: any) => s + (l.total_regle || 0),
      0
    );
  }

  get totalResteBoutique(): number {
    return this.livraisonsBoutique.reduce(
      (s: number, l: any) => s + (l.reste_a_regler || 0),
      0
    );
  }

  get totalResteGlobal(): number {
    return (
      (this.itemToSave.reste_a_regler || 0) +
      this.totalResteRestau +
      this.totalResteBoutique
    );
  }

  imprimerReglement(item: any) {
    let request = {
      data: {
        // telephone:this.client_search_key
        id: item.reglement_hebergement_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('pdf/printRecuHebergement', request).subscribe(
      (res: any) => {
        if (res && res['item'] && !res['hasError']) {
          this.printService.previewPdf(res['item'].link);
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
        }
      },
      (err) => {}
    );
  }
}
